module.exports = __webpack_public_path__ + "img/inghomepay.08916f3.svg";